window.FreeGiftPromo = {
  enforce: function () {
    var cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    var giftRows = cartItems.querySelectorAll('[data-is-gift="true"]');
    for (var i = 0; i < giftRows.length; i++) {
      var row = giftRows[i];
      var hasDiscount = row.dataset.hasDiscount === 'true';
      var finalPrice = parseInt(row.dataset.finalPrice, 10);

      if (!hasDiscount || finalPrice !== 0) {
        var line = row.id.replace('CartItem-', '');
        cartItems.updateQuantity(line, 0);
      }
    }
  }
};
